export default __webpack_public_path__ + "static/media/mintsite_graphic_1.1bcdae22.png";